import React from 'react';

import { Money, formatMoney } from '@betterment/core';

import { DetailRowValue } from './DetailRowValue';

interface DetailRowMoneyValueProps {
  value: Money;
}

export const DetailRowMoneyValue: React.FC<DetailRowMoneyValueProps> = ({ value }) => {
  return <DetailRowValue>{formatMoney(value)}</DetailRowValue>;
};
